// extracted by mini-css-extract-plugin
export default {"header":"header___UEooA","subheader":"subheader___wQdc4"};